<h1 class="mt-5">Reporte estado avance de secciones</h1>

<!-- DETALLE CONFIGURACIÓN -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Criterios de búsqueda</h6>
</div>

<div *ngIf="alertaExitosa !== ''" class="alert alert-success tipografía_alertas mt-4 mb-4" role="alert">
	<i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>
	{{ alertaExitosa }}
</div>

<form class="form" [formGroup]="parametrosForm">
	<div class="row mt-5 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
			<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<select id="select_anyo" class="form-control select_criterios" formControlName="anyo" [(ngModel)]="filtroAnyo" (ngModelChange)="resetearValidacion();cargarFiltros('anyo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let anyo of listaAnyo" [value]="anyo">{{anyo}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['anyo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
			<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="periodo" [(ngModel)]="filtroPeriodo" (ngModelChange)="resetearValidacion();cargarFiltros('periodo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let periodo of listaPeriodo" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback position-absolute">
					<div *ngIf="tieneErrores['periodo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-3">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
			<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<label class="titulo_criterios-obligatorio ml-2" *ngIf="!rolDaraCentral">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="sede" [(ngModel)]="filtroSede" (ngModelChange)="resetearValidacion();cargarFiltros('sede')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['sede'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let sede of listaSede" [value]="sede.sedeId">{{sede.descripcion}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['sede']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErrores['sede']">Campo requerido</div>
			</div>
		</div>
		<div class="col-3">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Sigla asignatura</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="asignatura" [(ngModel)]="filtroAsignaturas" (ngModelChange)="resetearValidacion();cargarFiltros('asignatura')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['asignatura'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let asignatura of listaAsignaturas" [value]="asignatura.id">{{asignatura.codigo}}</option>
			</select>
		</div>
		<div class="col-1 centrar_iconos_botones">
			<button (click)="actualizarLista()" class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR"><i class="bi bi-search"></i></button>
		</div>
		<div class="col-1 centrar_iconos_botones">
			<button (click)="limpiarFiltros()" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="ELIMINAR" alt="ELIMINAR"><i class="bi bi-x"></i></button>
		</div>
	</div>
	<div class="row mt-4 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">ID Docente</label>
			<div class="input-group">
				<mat-autocomplete #autoDocentes="matAutocomplete" [displayWith]="displayFnCodDocentes">
					<mat-option *ngFor="let docente of filteredCodDocentes | async" [value]="docente">
							{{docente?.codigo}}
					</mat-option>
				</mat-autocomplete>
				<input type="text" (keypress)="keypressNumber($event)" id="inputCodDocente" [formControl]="searchCodDocenteForm" formControlName="idDocente" [matAutocomplete]="autoDocentes" class="form-control select_criterios" placeholder="" (ngModelChange)="resetearValidacion('inputSearchCodDocente')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['idDocente'] }">
				<div *ngIf="submitted && tieneErrores['idDocente']" class="invalid-feedback">
					<div *ngIf="tieneErrores['idDocente']" class="position-absolute">Campo requerido</div>
				</div>
			</div>
		</div>
	</div>
</form>

<div class="row justify-content-end mt-5">
	<button (click)="generarReporte()" class="boton-primario mr-4 mt-2" style="position: absolute; z-index: 1;"><i class="bi bi-plus-lg mr-2"></i>GENERAR REPORTE</button>
</div>

<!-- TABLA -->
<div style="margin-top: 20px;" class="pb-3">
	<table *ngIf="renderTable" datatable [dtOptions]="dtOptions" class="row-border hover table-striped display nowrap " aria-describedby="tabla reemplazo docente">
		<thead class="header_tabla">
			<tr>
				<th class="py-2">IdProceso</th>
				<th class="py-2">Fecha</th>
				<th class="py-2">Usuario</th>
				<th class="py-2">Estado del proceso</th>
				<th class="py-2">Observaciones</th>
				<th class="py-2">Descargar archivo</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let reporte of listaReporteAvanceSecciones; index as indexSeccion">
				<td class="py-2">{{ reporte.idProceso }}</td>
				<td class="py-2">{{ reporte.fechaProceso }}</td>
				<td class="py-2">{{ reporte.usuarioCreacion }}</td>
				<td class="py-2">
					<span class="badge badge-pill finalizado d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'F'">Finalizado</span>
					<span class="badge badge-pill en_proceso d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'EP'">En proceso</span>
					<span class="badge badge-pill error d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'ER'">Error</span>
				</td>
				<td class="py-2">{{ reporte.mensajeProceso }}</td>
				<td class="py-2">
					<div class="d-flex justify-content-center align-items-center"  *ngIf="reporte.estadoProceso == 'F'">
						<div>
							<button class="btn p-0" data-toggle="tooltip" data-placement="top" (click)="obtenerReporteExcel(reporte.idProceso)" title="DESCARGAR REPORTE EXCEL" alt="DESCARGAR REPORTE EXCEL"> 
								<i class="bi bi-filetype-xlsx icono-tabla"></i>
							</button>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<!-- FIN TABLA -->

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Launch demo modal
</button>